import { ProfileSection, ProfileSections } from '../../components/ProfileSection';
import styles from './style.module.scss';

const KYC_LABELS: Record<string, string> = {
    approved: 'ID verified',
    notApproved: 'ID not verified',
};

interface Props {
    kycStatus: string;
    avatar: string | null;
};

export default function Identifying({ avatar, kycStatus }: Props) {
    return (
        <ProfileSections gap='sm'>
            <ProfileSection title='Personal photo' layout='inlineFlush'>
                <div className={styles.avatar}>
                    <img src={avatar || ''} alt='' />
                </div>
            </ProfileSection>

            <ProfileSection title='ID' layout='inlineFlush'>
                <span className={styles.status} data-kyc-status={kycStatus}>
                    {KYC_LABELS[kycStatus]}
                </span>
            </ProfileSection>
        </ProfileSections>
    );
};
